import { useDispatch, useSelector } from 'react-redux';
import { progressSelector } from '../../../../../store/slices/dashboardSlice/dashboardSlice';

export const useProgressCard = (id: string) => {
    //@ts-ignore
    const { is_customer, progress_tariff_access_edit } = useSelector(
        //@ts-ignore
        (state) => state.dashboardReducer
    );

    const progressEntities = useSelector(progressSelector.selectEntities);
    const currentProgress = progressEntities[id];
    return { currentProgress, is_customer, progress_tariff_access_edit };
};
